module.exports = __webpack_public_path__ + "img/head-side-medical.ed570091.svg";